module.exports = __webpack_public_path__ + "media/images/emblems/Pleigne-Blazono-d5f406f04bd15dbfd606ef2c41b0bb4a.png";